import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { useEffect } from 'react';
import { Card, IconButton } from '@radix-ui/themes';
import { IconX } from '@tabler/icons-react';
import { trpcConsumerGetWebsiteCart } from '@trashlab/api/src/generated/hooks';
import { OrderConfirmationStep } from '@trashlab/sitesapp/src/organizations/redebins/components/shop/steps/order-confirmation-step';
import { useNavigate } from '@tanstack/react-router';

const ThankYouPage = () => {
  const { cartId } = Route.useParams();
  const navigate = useNavigate();
  const { data: cartData, isLoading } = trpcConsumerGetWebsiteCart.useQuery({
    id: cartId,
  });

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  const handleClose = () => {
    navigate({ to: '/' });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!cartData) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          e.preventDefault();
          e.stopPropagation();
          handleClose();
        }
      }}
    >
      <Card className="max-w-[min(1200px,calc(100vw-32px))] w-full h-[min(750px,calc(100vh-32px))] p-0 rounded-lg overflow-hidden flex flex-col relative">
        <IconButton
          className="absolute top-3 right-3 z-10 rounded-full cursor-pointer"
          color="gray"
          size="1"
          onClick={handleClose}
        >
          <IconX />
        </IconButton>

        <OrderConfirmationStep cartData={cartData} />
      </Card>
    </div>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cart/$cartId/thankyou',
  parseParams: (params: Record<string, string>) => ({
    cartId: params.cartId,
  }),
  component: ThankYouPage,
});
